import { render, staticRenderFns } from "./LiteratureDetail.vue?vue&type=template&id=53544036&scoped=true"
import script from "./LiteratureDetail.vue?vue&type=script&lang=js"
export * from "./LiteratureDetail.vue?vue&type=script&lang=js"
import style0 from "./LiteratureDetail.vue?vue&type=style&index=0&id=53544036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53544036",
  null
  
)

export default component.exports